import './Fonts/_font.css'

import { createTheme, adaptV4Theme } from '@mui/material/styles';

const defaultTheme = createTheme();

const theme = createTheme(adaptV4Theme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 1024,
            lg: 1280,
            xl: 1920,
        }
    },
    palette: {
        type: 'dark',
        primary: {
            main: '#d09705',
            light: '#d7a72b',
        },
        secondary: {
            main: '#121212',
            light: 'rgba(255, 255, 255, 0.7)',
            dark: '#323232',
            contrastText: '#fff',
            muted: '#bbb',
            muted2: 'rgba(255, 255, 255, 0.7)',
            border: '#393939',
            black: '#000000'
        },
        background: {
            paper: '#323232',
            menu: {
                inactive: {
                    color: 'rgba(255, 255, 255, 0.7)',
                },
                hover: {
                    color: '#fff',
                    backgroundColor: 'rgba(255, 255, 255, 0.05)',
                },
                active: {
                    backgroundColor: 'rgba(255, 255, 255, 0.10)',
                },
            },
        },
    },
    typography: {
        fontFamily: "GTWalsheimPro",
        fontWeightThin: 100,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightSemiBold: 600,
        fontWeightBold: 700,
        h1: {
            fontWeight: 400,
            fontSize: '96px',
            lineHeight: '112px',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontWeight: 400,
            fontSize: '60px',
            lineHeight: '72px',
            letterSpacing: '-0.5px',
        },
        h3: {
            fontWeight: 400,
            fontSize: '48px',
            lineHeight: '56px',
        },
        h4: {
            fontWeight: 400,
            fontSize: '34px',
            lineHeight: '36px',
        },
        h5: {
            fontWeight: 400,
            fontSize: '24px',
            lineHeight: '24px',
            letterSpacing: '0.18px'
        },
        h6: {
            fontWeight: 600,
            fontSize: '20px',
            lineHeight: '26px',
            letterSpacing: '0.15px'
        },
        subtitle1: {
            fontWeight: 400,
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.15px'
        },
        subtitle2: {
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '24px',
            letterSpacing: '0.1px'
        },
        body1: {
            fontWeight: 400,

            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: '0.5px'
        },
        body2: {
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.25px'
        },
        button: {
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '16px',
            letterSpacing: '1.25px'
        },
        caption: {
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '0.4px'
        },
        overline: {
            fontWeight: 600,
            fontSize: '10px',
            lineHeight: '16px',
            letterSpacing: '1.5px'
        },
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': "GTWalsheimPro",
            },
        },
        MuiButtonBase: {
            root: {
                "&:focus-visible": {
                    outline: "1px solid #fff",
                },
            },
        },
        MuiButton: {
            root: {
                borderRadius: 0,
                color: 'inherit',

                "& svg": {
                    height: "1em",
                },
            },
        },
        MuiInputBase: {
            root: {
                "--border-color": "rgba(255,255,255,.7)",
                "--icon-color": "var(--border-color)",
                color: "#fff",
                border: "1px solid var(--border-color)",
                padding: ".25rem .5rem",
                transition: defaultTheme.transitions.create(['border-color']),
                "&::after, &::before": {
                    display: "none",
                },
                "&:hover": {
                    "--border-color": "#d09705",
                },
                "&.Mui-focused": {
                    "--border-color": "currentColor",
                    color: "#fff",
                },
                "& svg path": {
                    fill: "var(--icon-color)",
                    transition: defaultTheme.transitions.create(['fill']),
                }
            }
        },
        MuiInput: {
            input: {
                "&::placeholder": {
                    color: '#323232',
                    opacity: 1,
                },
            }
        },
        MuiAlert: {
            root: {
                borderRadius: 0,
                color: '#ffffff',
                boxShadow: "0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)",
            },
            message: {
                color: '#fff',
            },
            action: {
                paddingLeft: defaultTheme.spacing(8),
                color: 'rgba(255, 255, 255, 0.7)',
            },
            standardError: {
                backgroundColor: "#83182A",
            },
            standardInfo: {
                backgroundColor: "#000",
            }
        },
        MuiToolbar: {
            root: {
                //alignItems: "stretch",
            }
        }
    },
    props: {
        // Name of the component
        MuiButtonBase: {
            // The properties to apply
            disableRipple: true, // No more ripple, on the whole application!
        },
        MuiPaper: {
            square: true,
        },
        MuiList: {
            disablePadding: true,
        }
    }
}));
console.log("theme", theme);

export default theme;